// fc-availability.js — keeps the PDP availability badge + shipping line in sync with the
// selected variant. Mirrors Horizon's product-inventory / product-price blocks: on a
// `variant:update` the product section is re-rendered server-side and the new HTML is handed
// to us on the event; we find our own freshly-rendered element in it and swap our content in.
// Vanilla custom element (project rule: no frameworks); only the official event name is imported.
import { ThemeEvents } from '@theme/events';

class FcAvailability extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.update = this.update.bind(this);
    this.section?.addEventListener(ThemeEvents.variantUpdate, this.update);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(ThemeEvents.variantUpdate, this.update);
  }

  update(event) {
    // When the variant belongs to a different product on the page (e.g. a quick-add card),
    // ignore it — only react to our own product's updates.
    if (event.detail?.data?.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const next = event.detail?.data?.html?.querySelector(
      `fc-availability[data-block-id="${this.dataset.blockId}"]`
    );
    if (!next) return;

    this.innerHTML = next.innerHTML;
  }
}

if (!customElements.get('fc-availability')) {
  customElements.define('fc-availability', FcAvailability);
}
